import React, { Component } from "react";
import "assets/jss/material-kit-react/views/gntPage.css";
import {
  insertEdocument,
  btoa,
  _callApiMessage,
  _parceDate
} from "GlobalFunction";
const Today = new Date();
const TodayYear = Today.getFullYear();
const TodayMonth = _parceDate(Today.getMonth() + 1);
const TodayDay = _parceDate(Today.getDate());
class GntChart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedTab: 1,
      today: `${TodayYear - 1}-${TodayMonth}-${TodayDay}`,
      nextDay: `${TodayYear + 1}-${TodayMonth}-${TodayDay}`,
      searchAll: ""
    };
  }
  onBtnClick = (event, gubun) => {
    const target = event.target;
    this.setState({
      selectedTab: gubun
    });
  };
  handleChange = e => {
    let nextState = {};
    nextState[e.target.name] = e.target.value;
    this.setState(nextState);
  };
  componentDidMount() {
    this.setState({
      USER_INFO: JSON.parse(localStorage.getItem("USERINFO"))
    });
  }
  render() {
    return (
      <div className="gntContainer">
        <div>
          <label className="lbl-Project">PROJECT</label>
        </div>
        <div style={{ marginTop: "50px" }}>
          <button
            className={`btn-Project ${
              this.state.selectedTab === 1 ? "btn-Project-On" : ""
            }`}
            onClick={e => this.onBtnClick(e, 1)}
          >
            PC
          </button>
          <button
            className={`btn-Project ${
              this.state.selectedTab === 2 ? "btn-Project-On" : ""
            }`}
            onClick={e => this.onBtnClick(e, 2)}
          >
            Mobile
          </button>
          <button
            className={`btn-Project ${
              this.state.selectedTab === 3 ? "btn-Project-On" : ""
            }`}
            onClick={e => this.onBtnClick(e, 3)}
          >
            Web
          </button>
          <button
            className={`btn-Project ${
              this.state.selectedTab === 4 ? "btn-Project-On" : ""
            }`}
            onClick={e => this.onBtnClick(e, 4)}
          >
            Design
          </button>
        </div>
        <div className="input-container">
          <div>
            <label>빠른 입력 : </label>
            <label>{this.state.USER_INFO && this.state.USER_INFO.SUName}</label>
            <input
              style={{ width: "350px", margin: "0 30px", height: "30px" }}
            />
            <input type="file" onChange={this.handleFileChange} />
            <button>입력</button>
          </div>
          <div>
            <label>세부 입력 : </label>
            <button>작성</button>
          </div>
        </div>
        <div className="input-container">
          <div>
            {" "}
            <label>키워드</label>
            <input
              onChange={this.handleChange}
              name="searchAll"
              value={this.state.searchAll}
            />
          </div>
          <div>
            <label>기간</label>
            <input
              type="date"
              onChange={this.handleChange}
              name="today"
              value={this.state.today}
            />
            <label>~</label>
            <input
              type="date"
              onChange={this.handleChange}
              name="nextDay"
              value={this.state.nextDay}
            />
            <button>검색</button>
          </div>
        </div>
        <div
          style={{
            marginTop: "50px",
            display: "flex",
            flexDirection: "row",
            borderBottom: "0.5px solid",
            padding: "15px 0"
          }}
        >
          <div style={{ width: "150px" }}>
            <label>작성자</label>
          </div>
          <div style={{ width: "350px" }}>
            <label>내용</label>
          </div>
          <div style={{ width: "150px" }}>
            <label>요청일</label>
          </div>
          <div style={{ width: "150px" }}>
            <label>처리일</label>
          </div>
          <div style={{ width: "150px" }}>
            <label>첨부파일</label>
          </div>
          <div style={{ width: "200px" }} />
        </div>
        <div
          style={{
            padding: "15px 0",
            display: "flex",
            flexDirection: "row",
            borderBottom: "1px dotted"
          }}
        >
          <div style={{ width: "150px" }}>
            <label>김종우</label>
          </div>
          <div style={{ width: "350px" }}>
            <label>전자문서 리스트</label>
          </div>
          <div style={{ width: "150px" }}>
            <label>2019-04-29</label>
          </div>
          <div style={{ width: "150px" }}>
            <label />
          </div>
          <div style={{ width: "150px" }}>
            <button>다운로드</button>
          </div>
          <div style={{ width: "200px" }}>
            <button className="btn-success">완료</button>
            <button className="btn-success-no">삭제</button>
          </div>
        </div>
        <div
          style={{
            padding: "15px 0",
            display: "flex",
            flexDirection: "row",
            borderBottom: "1px dotted"
          }}
        >
          <div style={{ width: "150px" }}>
            <label>김종우</label>
          </div>
          <div style={{ width: "350px" }}>
            <label>전자문서 리스트2</label>
          </div>
          <div style={{ width: "150px" }}>
            <label>2019-04-29</label>
          </div>
          <div style={{ width: "150px" }}>
            <label>2019-04-29</label>
          </div>
          <div style={{ width: "150px" }}>
            <button>다운로드</button>
          </div>
          <div style={{ width: "200px" }}>
            <button className="btn-success-no">미완료</button>
            <button className="btn-success-no">삭제</button>
          </div>
        </div>
      </div>
    );
  }
}

export default GntChart;
